// Router.jsx
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import CompanyMainPage from "./Pages/CompanyMainPage";
import DashboardMainPage from "./Pages/DashboardMainPage";
import CompanyDataListMain from "./Pages/CompanyDataListMain";
import CertificationPage from "./Pages/CertificationPage";
import AddNewCertificationPage from "./Pages/AddNewCertificationPage";
import ViewPage from "./components/Certification/view/ViewPage";
import EditPage from "./components/Certification/edit/EditPage";
import CertificationTable from "./components/Certification/certification page/CertificationTable";
import SurvellianceMainpage from "./Pages/SurvellianceMainpage";
import RemainderTable from "./components/Survelliance audit/remainder/RemainderTable";
import SecondSurvellianceMainPage from "./Pages/SecondSurvellianceMainPage";
import RemainderTablePage from "./components/Second survelliance audit/remainder page/RemainderTablePage";
import ExpiredCertificationPage from "./Pages/ExpiredCertificationPage";
import AgentsTablePage from "./Pages/AgentsTablePage";
import Login from "./components/Authentication/Login";
import UserTablePageMain from "./Pages/UserTablePageMain";
import Register from "./components/Authentication/Register";
import OtpVerification from "./components/Authentication/OtpVerification";
import ForgotPassword from "./components/Authentication/ForgotPassword";
import CreateNewPassword from "./components/Authentication/CreateNewPassword";
import DetailsTable from "./components/company data list/details/DetailsTable";
import AuditsTable from "./components/company data list/audits/AuditsTable";
import NotificationTableMain from "./Pages/notificationPage/NotificationTableMain";
import ReportsMainPage from "./Pages/reports main page/ReportsMainPage";
import ExpiredCertifications from "./components/Reports/ExpiredCertifications";
import AuditSurvellianceReport from "./components/Reports/AuditSurvellianceReport";
import RenewalStatusReport from "./components/Reports/RenewalStatusReport";
import ProtectedRoute from "./ProtectedRoute";
// import { IndividualTraineePage } from "./Pages/IndividualTrainee/IndividualTraineePage";
// import AddIndividualTrainee from "./components/IndividualTrainee/AddIndividualTrainee";
// import EditIndividualTrainee from "./components/IndividualTrainee/EditIndividualTrainee";
// import ViewIndividualPage from "./components/IndividualTrainee/ViewIndividualTrainee";
import SettingsMainPage from "./Pages/Settings page/SettingsMainPage";
import { VendorPage } from "./Pages/Vendor/VendorPage";
import AddTaxInvoice from "./components/TaxInvoice/AddTaxInvoie";
import TaxInvoiceTable from "./components/TaxInvoice/TaxInvoiceTable";
import StandardTable from "./components/Standards/StandardTable";
import TaxInvoicePage from "./components/TaxInvoice/TaxInvoicePage";
import TDSTableMain from "./Pages/Tds reports/TDSTableMain";
import GSTReportTableMain from "./Pages/Gst report page/GSTReportTableMain";
import { BankDetailsPage } from "./Pages/BankDetails/BankDetails";
import EditTaxInvoice from "./components/TaxInvoice/EditTaxInvoice";
import ProformaInvoicePage from "./components/ProformaInvoice/ProformaInvoicePage";
import ProformaInvoiceTable from "./components/ProformaInvoice/ProformaInvoiceTable";
import AddProformaInvoice from "./components/ProformaInvoice/AddProformaInvoie";
import EditProformaInvoice from "./components/ProformaInvoice/EditProformaInvoice";
import AddInvoice from "./components/TaxInvoice/AddInvoice";
import PendingPaymentMain from "./Pages/pending payments page/PendingPaymentMain";
import { ManagerPage } from "./Pages/Manager/ManagerPage";
import InvoiceViewPage from "./components/company data list/certifications/InvoiceViewPage";
import Users from "./components/Users/Users";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register-page" element={<Register />} />
        <Route path="/otp-verification" element={<OtpVerification />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/create-password" element={<CreateNewPassword />} />
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<DashboardMainPage />} />
          <Route path="/companies" element={<CompanyMainPage />} />
          <Route path="/audits/companies" element={<AuditsTable />} />
          <Route path="/details-page/companies" element={<DetailsTable />} />
          <Route
            path="/company-details/:id"
            element={<CompanyDataListMain />}
          />
          <Route path="/tax-invoice" element={<TaxInvoiceTable />} />
           <Route
            path="/add-tax-invoice"
            element={<AddTaxInvoice />}
          />
          <Route path="/add-initial-tax-invoice/:id" element={<AddInvoice/>}/>
          <Route path="/edit-tax-invoice/:id" element={<EditTaxInvoice/>}/>
          <Route path="/proforma-invoice" element={<ProformaInvoiceTable />} />
           <Route
            path="/add-proforma-invoice"
            element={<AddProformaInvoice />}
          />
          <Route path="/edit-proforma-invoice/:id" element={<EditProformaInvoice/>}/>

          <Route
            path="/addnewcertification"
            element={<AddNewCertificationPage />}
          />
          <Route path="/view-certification/:id" element={<ViewPage />} />
          <Route path="/edit-certification/:id" element={<EditPage />} />
         
          <Route path="/agents-page" element={<AgentsTablePage />} />
           <Route path="/standards-list" element={<StandardTable />} />

          {/* Protected route - only admin can access */}
          <Route
            path="/usertable-page"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <UserTablePageMain />
              </ProtectedRoute>
            }
          />{" "}
          <Route
            path="/notification-table/notification"
            element={<NotificationTableMain />}
          />
          <Route path="/reports-page" element={<ReportsMainPage />} />
          <Route path="/bank-details-page" element={<BankDetailsPage />} />

          <Route
            path="/expired-certifications-reports"
            element={<ExpiredCertifications />}
          />
          <Route
            path="/audit-survelliance-page/reports"
            element={<AuditSurvellianceReport />}
          />
          <Route
            path="/renewal-status-page/reports"
            element={<RenewalStatusReport />}
          />
          <Route path="/settings" element={<SettingsMainPage/>}/>
          <Route path="/tax-invoice-page/:id" element={<TaxInvoicePage/>} />
          <Route path="/view-invoice-page/:id" element={<InvoiceViewPage/>} />
           <Route path="/proforma-invoice-page/:id/" element={<ProformaInvoicePage/>} />
          <Route path="/tds-reports-table" element={<TDSTableMain/>}/>
          <Route path="/gst-reports-table" element={<GSTReportTableMain/>}/>
          <Route path="/pending-payments-list" element={<PendingPaymentMain/>}/>
           <Route
            path="/managers-page"
            element={<ManagerPage />}
          />
           <Route path="/vendors-page" element={<VendorPage />} />
            <Route path="/users" element={<Users/>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
